module.exports = __webpack_public_path__ + "img/logo.5be2e914.png";